import { withRouter } from "found";
import { LoginBtnCmpt } from "./LoginBtn";

const LoginBtnNoRouter = LoginBtnCmpt;
// stupid hack to force this awkard pattern
const LoginBtn = withRouter(LoginBtnCmpt as any) as typeof LoginBtnNoRouter;
export { LoginBtnNoRouter, LoginBtn };
